module.exports = __webpack_public_path__ + "static/media/axegpromouse-5.4412fec4.jpg";